import { SubscriptionDetail } from "api/company";
import moment from "moment";
import { UserTypes } from "api/user";

export const capitalize = (word: string) => (word.charAt(0).toUpperCase() + word.slice(1));
export const formatter = Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
export const isValidPassword = (password: string) => (!(password.match(/[A-Z]/g)) || password.length < 8);
export const isValidVerificationCode = (code: string) => (!(code.match(/^\d+$/)) || code.length < 8);
export enum BeaconCommand {
    INIT = "init",
    CONFIG = "config",
    DESTROY = "destroy",
}
export enum ErrorTypes {
    CLUB_IN_DEMO_MODE = "clubIsInDemoMode",
    USED_BUDGET_EXCEEDS_MONTHLY_TOTAL_BUDGET = "usedBudgetExceedsMonthlyTotalBudget",
    COMPANY_PROFILE_NOT_FOUND = "companyProfileNotFound",
    COMPANY_HAS_NO_ACTIVE_SUBSCRIPTION = "companyHasNoActiveSubscription",
    INVALID_PASSWORD_FORMAT = "invalidPasswordFormat",
    UN_KNOWN_AUTH_ERROR = "unknownAuthError",
}
export const markdownIfYoutubelink = (word: string) => (["https://youtu.be/", "https://www.youtube.com/"].some((link) => word.includes(link)) ? `[${word}](${word})` : word);
export const formattedDate = (date: Date) => moment(date).format("DD.MM.YYYY HH:mm");

export const isAllowRequestTypes = (club: { capabilities: string | string[]; }) => (club?.capabilities.includes("sip") || club?.capabilities.includes("public-ground") || club?.capabilities.includes("commercial"));

export const helpB2BLink = "https://help.playsports.world/category/238-unternehmen";
export const helpLink = "https://help.playsports.world/category/178-partnerclubs";

export const isActiveSubscription = (subscriptionDetail: SubscriptionDetail) => (subscriptionDetail?.subscriptionInfos?.cancel_at_period_end === false && subscriptionDetail?.subscriptionInfos?.status === "active");

export const isUserBelongsToRoot = (userTypes?: UserTypes) => (userTypes?.includes("root-management") || userTypes?.includes("root-dev") || userTypes?.includes("root-marketing") || userTypes?.includes("root-sales") || userTypes?.includes("root-support"));
